import { z } from 'zod';
export const TYPES_ENTREE_CRISE = {
  DECISION: 'Décision',
  MEANS: 'Moyens mobilisés',
  COMMUNICATION: 'Communication',
  NOTE: 'Note de situation',
} as const;
export const schemaEntreeCrise = z
  .object({
    requete_id: z.string().uuid(),
    type: z.enum(['DECISION', 'MEANS', 'COMMUNICATION', 'NOTE']),
    contenu: z.string().trim().min(3).max(2000),
  })
  .strict();
